<template>
  <div v-if="isViewSet">
    <!-- Form Example -->
    <d-form>
      <d-form-row v-if="guarantee.id">
          <d-col class="text-right">
            <d-button
              theme="info"
              @click.prevent="showObligationsModal">
              <i class="material-icons">format_list_bulleted</i> Zarządzaj zobowiązaniami
            </d-button>
          </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>{{ getFieldLabel('type') }}</label>
          <d-select
            name="type"
            v-model="guarantee.type"
            v-validate="'required'"
            @input="errors.clear('type')"
            :class="{'is-invalid' : errors.has('type')}"
            :disabled="!!guarantee.id">
            <option
              :value="null"
              label="--Wybierz typ"
              default
              disabled>
            </option>
            <option
              v-for="optionItem in availableTypesOptions"
              :value="optionItem.value">
              {{ optionItem.label }}
            </option>
          </d-select>
          <div class="invalid-feedback">
            {{ errors.first('type') }}
          </div>
        </d-col>
        <d-col
          v-if="isViewSet && fieldsForType.includes('number_land_mortgate_register')"
          md="6"
          class="form-group">
          <label for="number_land_mortgate_register">
            {{ getFieldLabel('number_land_mortgate_register') }} (np. AA1A/11111111/1)
          </label>
          <d-input
            id="number_land_mortgate_register"
            name="number_land_mortgate_register"
            v-model="guarantee.number_land_mortgate_register"
            v-validate="'required|regex:^[A-Z]{2}\\d[A-Z]/\\d{8}/\\d$'"
            @input="errors.clear('number_land_mortgate_register')"
            :class="{'is-invalid' : errors.has('number_land_mortgate_register')}"
            v-mask="'AA#A/########/#'"
            :placeholder="getFieldLabel('number_land_mortgate_register')" />
          <div class="invalid-feedback">
            {{ errors.first('number_land_mortgate_register') }}
          </div>
        </d-col>
      </d-form-row>

      <template v-if="isViewSet && guarantee.type && guarantee.type.length">
        <d-form-row v-if="fieldsForType.includes('pledge_type')">
          <d-col md="6" class="form-group">
            <label>{{ getFieldLabel('pledge_type') }}</label>
            <d-select
              name="pledge_type"
              v-model="guarantee.pledge_type"
              v-validate="'required'"
              @input="errors.clear('pledge_type')"
              :class="{'is-invalid' : errors.has('pledge_type')}">
              <option
                :value="null"
                label="--Wybierz rodzaj zastawu"
                default
                disabled>
              </option>
              <option
                v-for="optionItem in availablePledgeTypesOptions"
                :value="optionItem.value">
                {{ optionItem.label }}
              </option>
            </d-select>
            <div class="invalid-feedback">
              {{ errors.first('pledge_type') }}
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col
            v-if="fieldsForType.includes('device_name')"
            md="6"
            class="form-group"
            :key="'device-name-' + fieldsForType.includes('device_name')">
            <ss-input
              v-model="guarantee.device_name"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('device_name')}"
              name="device_name"
              :label="getFieldLabel('device_name')"
              :placeholder="getFieldLabel('device_name')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('device_name') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('car_brand')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.car_brand"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('car_brand')}"
              name="car_brand"
              :label="getFieldLabel('car_brand')"
              :placeholder="getFieldLabel('car_brand')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('car_brand') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('car_model')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.car_model"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('car_model')}"
              name="car_model"
              :label="getFieldLabel('car_model')"
              :placeholder="getFieldLabel('car_model')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('car_model') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('car_register')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.car_register"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('car_register')}"
              name="car_register"
              :label="getFieldLabel('car_register')"
              :placeholder="getFieldLabel('car_register')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('car_register') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('car_registration_number')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.car_registration_number"
              v-validate="guarantee.pledge_type === 'CAR' ? 'required' : ''"
              :class="{'is-invalid' : errors.has('car_registration_number')}"
              name="car_registration_number"
              :label="getFieldLabel('car_registration_number')"
              :placeholder="getFieldLabel('car_registration_number')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('car_registration_number') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('car_vin')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.car_vin"
              v-validate="{
                required: guarantee.pledge_type === 'CAR'
              }"
              :class="{'is-invalid' : errors.has('car_vin')}"
              name="car_vin"
              :label="getFieldLabel('car_vin')"
              :placeholder="getFieldLabel('car_vin')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('car_vin') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('production_year')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.production_year"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('production_year')}"
              name="production_year"
              :label="getFieldLabel('production_year')"
              :placeholder="getFieldLabel('production_year')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('production_year') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('value')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.value"
              name="value"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('value')}"
              :label="getFieldLabel('value')"
              :placeholder="getFieldLabel('value')"></ss-input>
            <div class="invalid-feedback">
              {{ errors.first('value') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('shares_value')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.shares_value"
              name="shares_value"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('shares_value')}"
              :label="getFieldLabel('shares_value')"
              :placeholder="getFieldLabel('shares_value')"></ss-input>
              <div class="invalid-feedback">
                {{ errors.first('shares_value') }}
              </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('shares_number')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.shares_number"
              v-validate="'required|min_value:0.1'"
              :class="{'is-invalid' : errors.has('shares_number')}"
              name="shares_number"
              :label="getFieldLabel('shares_number')"
              :placeholder="getFieldLabel('shares_number')"></ss-input>
              <div class="invalid-feedback">
                {{ errors.first('shares_number') }}
              </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('other')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.other"
              name="other"
              :label="getFieldLabel('other')"
              :placeholder="getFieldLabel('other')"></ss-input>
          </d-col>
        </d-form-row>

        <d-form-row v-if="fieldsForType.includes('number_land')">
          <d-col md="6" class="form-group">
            <ss-input
              v-model="guarantee.number_land"
              name="number_land"
              :label="getFieldLabel('number_land')"
              :placeholder="getFieldLabel('number_land')" />
          </d-col>
        </d-form-row>

        <template v-if="fieldsForType.includes('pledge_type')">
          <hr class="mt-2 mb-4" />

          <p class="font-weight-bold mt-3 mb-3">
            Położenie zastawu:
          </p>
        </template>

        <d-form-row>
          <d-col
            v-if="fieldsForType.includes('street')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.street"
              name="street"
              :label="getFieldLabel('street')"
              :placeholder="getFieldLabel('street')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('house_number')"
            md="3"
            class="form-group">
            <ss-input
              v-model="guarantee.house_number"
              name="house_number"
              :label="getFieldLabel('house_number')"
              :placeholder="getFieldLabel('house_number')"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('flat_number')"
            md="3"
            class="form-group">
            <ss-input
              v-model="guarantee.flat_number"
              name="flat_number"
              :label="getFieldLabel('flat_number')"
              :placeholder="getFieldLabel('flat_number')"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('postcode')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.postcode"
              name="postcode"
              :label="getFieldLabel('postcode')"
              placeholder="00-000"
              mask="##-###"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('city')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.city"
              name="city"
              :label="getFieldLabel('city')"
              :placeholder="getFieldLabel('city')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('province')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.province"
              name="province"
              :label="getFieldLabel('province')"
              :placeholder="getFieldLabel('province')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('county')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.county"
              name="county"
              :label="getFieldLabel('county')"
              :placeholder="getFieldLabel('county')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('community')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.community"
              name="community"
              :label="getFieldLabel('community')"
              :placeholder="getFieldLabel('community')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('district')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.district"
              name="district"
              :label="getFieldLabel('district')"
              :placeholder="getFieldLabel('district')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('court_city')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.court_city"
              name="court_city"
              :label="getFieldLabel('court_city')"
              :placeholder="getFieldLabel('court_city')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('court_jurisdiction')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.court_jurisdiction"
              name="court_jurisdiction"
              :label="getFieldLabel('court_jurisdiction')"
              :placeholder="getFieldLabel('court_jurisdiction')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('mortgage_amount')"
            md="6"
            class="form-group">
            <label>{{ getFieldLabel('mortgage_amount') }}</label>
            <ss-price-input
              v-model="guarantee.mortgage_amount"
              name="mortgage_amount"
              :class="{'is-invalid' : errors.has('type')}"
              placeholder="Kwota (zł)" />
            <div class="invalid-feedback">
              {{ errors.first('mortgage_amount') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('court_department_number')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.court_department_number"
              name="court_department_number"
              :label="getFieldLabel('court_department_number')"
              :placeholder="getFieldLabel('court_department_number')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('area')"
            md="6"
            class="form-group">
            <div class="form-group">
              <ss-input
                v-model="guarantee.area"
                name="area"
                :label="`${getFieldLabel('area')} (m<sup>2</sup>)`"
                :placeholder="getFieldLabel('area')" />
            </div>
          </d-col>
        </d-form-row>

        <hr
          v-if="fieldsForType.includes('pledge_type')"
          class="mt-2 mb-4" />

        <template v-if="fieldsForType.includes('company')">
          <hr class="mt-2 mb-4" />
          <p class="font-weight-bold mt-3 mb-3">
          Dane Spółki:
        </p>
        </template>
        <d-form-row>
          <d-col
            v-if="fieldsForType.includes('company')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.company"
              v-validate="'required'"
              :class="{'is-invalid' : errors.has('company')}"
              name="company"
              :label="getFieldLabel('company')"
              :placeholder="getFieldLabel('company')"/>
              <div class="invalid-feedback">
                {{ errors.first('company') }}
              </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('nip')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.nip"
              v-validate="'regex:^\\d{10}?$'"
              :class="{'is-invalid' : errors.has('nip')}"
              name="nip"
              :label="`${getFieldLabel('nip')} (10 cyfr)`"
              :placeholder="getFieldLabel('nip')" />
            <div class="invalid-feedback">
              {{ errors.first('nip') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('regon')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.regon"
              v-validate="'regex:^\\d{9}(\\d{5})?$'"
              :class="{'is-invalid' : errors.has('regon')}"
              name="regon"
              :label="`${getFieldLabel('regon')} (9 lub 14 cyfr)`"
              :placeholder="getFieldLabel('regon')" />
            <div class="invalid-feedback">
              {{ errors.first('regon') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('krs')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.krs"
              v-validate="'regex:^\\d{10}?$'"
              :class="{'is-invalid' : errors.has('krs')}"
              name="krs"
              :label="`${getFieldLabel('krs')} (10 cyfr)`"
              :placeholder="getFieldLabel('krs')" />
            <div class="invalid-feedback">
              {{ errors.first('krs') }}
            </div>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_street')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.company_street"
              name="company_street"
              :label="getFieldLabel('company_street')"
              :placeholder="getFieldLabel('company_street')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_house_number')"
            md="3"
            class="form-group">
            <ss-input
              v-model="guarantee.company_house_number"
              name="company_house_number"
              :label="getFieldLabel('company_house_number')"
              :placeholder="getFieldLabel('company_house_number')"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_flat_number')"
            md="3"
            class="form-group">
            <ss-input
              v-model="guarantee.company_flat_number"
              name="company_flat_number"
              :label="getFieldLabel('company_flat_number')"
              :placeholder="getFieldLabel('company_flat_number')"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_postcode')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.company_postcode"
              name="company_postcode"
              :label="getFieldLabel('company_postcode')"
              placeholder="00-000"
              mask="##-###"></ss-input>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_city')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.company_city"
              name="company_city"
              :label="getFieldLabel('company_city')"
              :placeholder="getFieldLabel('company_city')" />
          </d-col>
          <d-col
            v-if="fieldsForType.includes('company_province')"
            md="6"
            class="form-group">
            <ss-input
              v-model="guarantee.company_province"
              name="company_province"
              :label="getFieldLabel('company_province')"
              :placeholder="getFieldLabel('company_province')" />
          </d-col>
        </d-form-row>

        <hr
          v-if="fieldsForType.includes('company')"
          class="mt-2 mb-4" />

        <template v-if="fieldsForType.includes('shares_belong_to')">
          <d-form-row >
            <d-col md="6" class="form-group">
              <label>{{ getFieldLabel('shares_belong_to') }}</label>
              <d-select
                name="shares_belong_to"
                v-model="guarantee.shares_belong_to"
                v-validate="'required'"
                :class="{'is-invalid' : errors.has('shares_belong_to')}"
                @input="errors.clear('shares_belong_to')"
                placeholder="--Wybierz osobę">
                <option
                  :value="null"
                  label="--Wybierz osobę"
                  default
                  disabled>
                </option>
                <option
                  v-for="optionItem in shareBelongToOptions"
                  :value="optionItem.value">
                  {{ optionItem.label }}
                </option>
              </d-select>
              <div class="invalid-feedback">
                {{ errors.first('shares_belong_to') }}
              </div>
            </d-col>

            <d-col
              v-if="guarantee.shares_belong_to === 'guarantor'"
              md="6"
              class="form-group">
              <label>{{ getFieldLabel('shares_guarantor_id') }}</label>
              <d-select
                name="shares_guarantor_id"
                v-model="guarantee.shares_guarantor_id"
                v-validate="'required|min_value:1'"
                :class="{'is-invalid' : errors.has('shares_guarantor_id')}"
                :disabled="!guarantors.length"
                @input="errors.clear('shares_guarantor_id')"
                placeholder="">
                <option
                  :value="0"
                  :label="(guarantors.length ? '--Wybierz poręczyciela' : 'Brak zdefiniowanych poręczycieli')"
                  default
                  disabled>
                </option>
                <option
                  v-for="optionItem in guarantors"
                  :value="optionItem.id">
                  {{ optionItem.name }} {{ optionItem.surname }}
                </option>
              </d-select>
              <div class="invalid-feedback">
                <!-- since default value has to 0 we have custom message -->
                <span v-if="errors.has('shares_guarantor_id')">
                  To pole jest wymagane.
                </span>
              </div>
            </d-col>
          </d-form-row>

          <template v-if="guarantee.shares_belong_to === 'other'">
            <p class="font-weight-bold mt-3 mb-3">
              Dane osoby, której przysługują udziały:
            </p>
            <d-form-row>
              <d-col
                v-if="fieldsForType.includes('shares_person_firstname')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_firstname"
                  name="shares_person_firstname"
                  :label="getFieldLabel('shares_person_firstname')"
                  :placeholder="getFieldLabel('shares_person_firstname')" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_secondname')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_secondname"
                  name="shares_person_secondname"
                  :label="getFieldLabel('shares_person_secondname')"
                  :placeholder="getFieldLabel('shares_person_secondname')" />
              </d-col>

              <d-col
                v-if="fieldsForType.includes('shares_person_surname')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_surname"
                  name="shares_person_surname"
                  :label="getFieldLabel('shares_person_surname')"
                  :placeholder="getFieldLabel('shares_person_surname')" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_pesel')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_pesel"
                  name="shares_person_pesel"
                  :label="getFieldLabel('shares_person_pesel')"
                  :placeholder="getFieldLabel('shares_person_pesel')" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_id_card_type')"
                md="6"
                class="mb-3">
                <div :class="{'form-group mb-1': true, 'is-invalid' : errors.has('shares_person_id_card_type')}">
                  <label>{{ getFieldLabel('shares_person_id_card_type') }}</label>
                  <div v-for="idDocType in idDocumentsTypes" >
                    <d-form-radio
                      name="shares_person_id_card_type"
                      v-model="guarantee.shares_person_id_card_type"
                      v-validate="'required'"
                      :value="idDocType.value"
                      default>
                      {{ idDocType.label }}
                    </d-form-radio>
                  </div>
                </div>
                <div class="invalid-feedback">
                  {{ errors.first('shares_person_id_card_type') }}
                </div>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_id_card')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_id_card"
                  name="shares_person_id_card"
                  :label="getFieldLabel('shares_person_id_card')"
                  :placeholder="getFieldLabel('shares_person_id_card')"
                  v-mask="getSelectedDocTypeMask(guarantee.shares_person_id_card_type)" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_street')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_street"
                  name="shares_person_street"
                  :label="getFieldLabel('shares_person_street')"
                  :placeholder="getFieldLabel('shares_person_street')" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_house_number')"
                md="3"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_house_number"
                  name="shares_person_house_number"
                  :label="getFieldLabel('shares_person_house_number')"
                  :placeholder="getFieldLabel('shares_person_house_number')"/>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_flat_number')"
                md="3"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_flat_number"
                  name="shares_person_flat_number"
                  :label="getFieldLabel('shares_person_flat_number')"
                  :placeholder="getFieldLabel('shares_person_flat_number')"></ss-input>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_postcode')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_postcode"
                  name="shares_person_postcode"
                  :label="getFieldLabel('shares_person_postcode')"
                  placeholder="00-000"
                  mask="##-###"></ss-input>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_city')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_city"
                  name="shares_person_city"
                  :label="getFieldLabel('shares_person_city')"
                  :placeholder="getFieldLabel('shares_person_city')" />
              </d-col>
            </d-form-row>
            <d-form-row>
              <d-col
                v-if="fieldsForType.includes('shares_person_email')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_email"
                  v-validate="'email'"
                  name="shares_person_email"
                  :label="getFieldLabel('shares_person_email')"
                  :placeholder="getFieldLabel('shares_person_email')"
                  :class="{'is-invalid' : errors.has('shares_person_email')}"/>
                <div class="invalid-feedback">
                  {{ errors.first('shares_person_email') }}
                </div>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_phone')"
                md="6"
                class="form-group">
                <ss-input
                  v-model="guarantee.shares_person_phone"
                  name="shares_person_phone"
                  :label="getFieldLabel('shares_person_phone')"
                  :placeholder="getFieldLabel('shares_person_phone')" />
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_marital_status')"
                md="6"
                class="form-group">
                <label>{{ getFieldLabel('shares_person_marital_status') }}</label>
                <v-select
                  v-model="guarantee.shares_person_marital_status"
                  :options="ClientUtils._marital_statuses"
                  :reduce="(option) => option.value"
                  :searchable="false"
                  placeholder="Wybierz stan cywilny"
                  class="autocomplete-wrapper"
                  label="name">
                </v-select>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_property_separation')"
                md="6"
                class="form-group">
                <label>{{ getFieldLabel('shares_person_property_separation') }}</label>
                <v-select
                  v-model="guarantee.shares_person_property_separation"
                  :options="ClientUtils._property_separations"
                  :reduce="(option) => option.value"
                  :searchable="false"
                  placeholder="Wybierz opcję"
                  class="autocomplete-wrapper"
                  label="name">
                </v-select>
              </d-col>
              <d-col
                v-if="fieldsForType.includes('shares_person_marital_status_other')"
                md="6"
                class="form-group">
                <label>{{ getFieldLabel('shares_person_marital_status_other') }}</label>
                <textarea
                  type="text"
                  v-validate="'required'"
                  name="shares_person_marital_status_other"
                  v-model="guarantee.shares_person_marital_status_other"
                  :rows="2"
                  :class="{
                    'form-control': true,
                    'is-invalid' : errors.first('shares_person_marital_status_other')
                    }"
                  placeholder="Opis..." />
                <div class="invalid-feedback">{{ errors.first('shares_person_marital_status_other') }}</div>
              </d-col>
            </d-form-row>
          </template>
          <hr class="mt-2 mb-4"  />
        </template>

        <d-form-row>
          <d-col
            v-if="fieldsForType.includes('is_burdens_on_property')"
            md="6"
            class="form-group">
            <d-checkbox
              toggle
              v-model="guarantee.is_burdens_on_property">
              {{ getFieldLabel('is_burdens_on_property') }}
            </d-checkbox>
          </d-col>
          <d-col
            v-if="fieldsForType.includes('burdens_description') || fieldsForType.includes('burdens_amount')"
            md="6"
            class="form-group">
            <div
              v-if="fieldsForType.includes('burdens_description')"
              class="form-group">
              <ss-textarea
                v-model="guarantee.burdens_description"
                name="burdens_description"
                :label="getFieldLabel('burdens_description')"
                :placeholder="getFieldLabel('burdens_description')"
                :rows="3" />
            </div>
            <div v-if="fieldsForType.includes('burdens_amount')">
              <label>{{ getFieldLabel('burdens_amount') }}</label>
              <ss-price-input
                v-model="guarantee.burdens_amount"
                name="burdens_amount"
                label="Kwota obciążeń"
                placeholder="Kwota obciążeń" />
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col
            v-if="fieldsForType.includes('property_owner')"
            md="6"
            class="form-group">
            <ss-textarea
              v-model="guarantee.property_owner"
              name="property_owner"
              :label="getFieldLabel('property_owner')"
              :placeholder="getFieldLabel('property_owner')" />
          </d-col>
          <d-col
            md="6"
            class="form-group">
            <ss-textarea
              v-model="guarantee.comments"
              name="comments"
              :label="getFieldLabel('comments')"
              :placeholder="getFieldLabel('comments')" />
          </d-col>
        </d-form-row>

        <hr class="mt-4 mb-4"/>
        <p class="font-weight-bold mt-0 mb-4">
          Pliki:
        </p>

        <!-- File section -->
        <d-form-row
          v-if="filesTypesForGuarantee.length"
          class="mx-lg-n4">
          <d-col
            v-for="filesType in filesTypesForGuarantee"
            :key="'file-type-' + filesType.fileType"
            :md="getFileTypeHasDescription(filesType.fileType) ? 12 : 6"
            class="form-group pb-3 px-lg-4">
            <div class="d-flex align-items-center mb-2">
              <p class="my-1 mr-auto">{{ filesType.label }}</p>
              <d-button
                theme="success"
                class="flex-shrink-0 ml-2 my-1"
                outline
                @click.prevent="showFileUpload(null, null, filesType.fileType)">
                <i class="material-icons">add</i>Dodaj
              </d-button>
            </div>
            <guarantee-form-files-tabel
              :files-list="guaranteeFiles"
              :files-type="filesType.fileType"
              :has-file-description="getFileTypeHasDescription(filesType.fileType)"
              @editFile="showFileUpload"
              @downloadFile="downloadFile"
              @removeFile="removeFile" />
          </d-col>
        </d-form-row>
      </template>
    </d-form>

    <add-file-modal
      v-if="filesTypesForGuarantee.length"
      ref="addFileModal"
      @addFile="addFile"
      @updateFile="updateFile" />

    <guarantee-obligations-modal
      v-if="isObligationsModalVisible"
      :is-visible="isObligationsModalVisible"
      :guarantee="guarantee"
      @close="handleObligationsClose"
      @saved="handleObligationsSaved" />

      
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import SsPriceInput from '@/components/common/SsPriceInput'
import GuaranteeUtils from '@/utils/guarantee.js';
import GuaranteeFormFilesTabel from '@/components/client/GuaranteeFormFilesTabel.vue';
import IdDocumentsTypes from '@/data/id-documents-types.js';
import ClientUtils from '@/utils/client.js';
import AddFileModal from '@/components/common/AddFileModal.vue';
import GuaranteeObligationsModal from '@/components/client/contract-partials/guarantees/GuaranteeObligationsModal.vue';

export default {
  name: 'GuaranteeForm',
  components: {
    SsPriceInput,
    GuaranteeFormFilesTabel,
    AddFileModal,
    GuaranteeObligationsModal
  },
  props: {
    guaranteeProp: {
      default: () => {},
      type: Object
    },
    guarantors: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      availablePledgeTypesOptions: GuaranteeUtils.getAvailablePledgeTypes(),
      availableTypesOptions: GuaranteeUtils.getAvailableTypes(),
      filesTypes: GuaranteeUtils.getAvailableFilesTypes(),
      formFields: GuaranteeUtils.getFormFields(),
      guarantee: {},
      guaranteeFiles: [],
      isViewSet: false,
      shareBelongToOptions: GuaranteeUtils.getShareBelongToOptions(),
      isObligationsModalVisible: false
    }
  },
  computed: {
    filesTypesForGuarantee () {
      return this.filesTypes.filter(item => item.guaranteeTypes.includes(this.guarantee.type));
    },
    fieldsForType () {
      return GuaranteeUtils.getFieldsForType(this.guarantee.type, this.guarantee);
    },
    idDocumentsTypes () {
      return IdDocumentsTypes;
    },
    ClientUtils () {
      return ClientUtils;
    }
  },
  watch: {
    guaranteeFiles: {
      handler: function(newValue) {
        this.guarantee.docs = newValue;
      },
      deep: true
    }
  },
  mounted () {
    if (this.guaranteeProp) {
      this.guarantee = this.guaranteeProp;
      this.guarantee.docs = [];
    } else {
      this.guarantee = GuaranteeUtils.getDefaultGuaranteeObject();
    }

    this.setFilesArrays();

    this.$nextTick(() => {
      this.isViewSet = true;
    });
  },
  methods: {
    async validateForm () {
      let isValid = await this.$validator.validateAll();
      return isValid;
    },
    setFilesArrays () {
      for (let i = 0; i < this.guarantee.files.length; i++) {
        let file = JSON.parse(JSON.stringify(this.guarantee.files[i]));

        if (!this.guaranteeFiles[file.type]) {
          this.guaranteeFiles[file.type] = [];
        }

        this.guaranteeFiles.push(file);
      }
    },
    addFile (file, type, description = '') {
      this.guaranteeFiles.push({ file, type: type === 'other_files' ? '' : type, description });
    },
    updateFile (fileIndex, description = '') {
      this.guaranteeFiles[fileIndex].description = description;
    },
    removeFile (file, index, type) {
      if (file.id) {
        if (!this.guarantee.files_to_delete) {
          this.guarantee.files_to_delete = [];
        }
        this.guarantee.files_to_delete.push(file.id);
      }
      this.guaranteeFiles.splice(index, 1);
    },
    downloadFile (doc) {
      axios.post('api/payment-guarantees/download-payment-guarantee-document',
        { id: doc.id },
        { responseType: 'blob' }
      ).then(response => {
        let blob = new File([response.data], doc.filename );
        FileSaver.saveAs(blob);
      }).catch((error)=>{
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
      });
    },
    showFileUpload (file, index, fileType) {
      this.$refs.addFileModal.showModal(fileType, this.getFileTypeHasDescription(fileType), file, index);
    },
    getFieldLabel (field) {
      return GuaranteeUtils.getFieldLabel(this.guarantee, field);
    },
    getSelectedDocTypeMask (docType) {
      let foundType = this.idDocumentsTypes.find(item => item.value === docType);
      if (foundType) {
        return foundType.mask;
      }

      return 'AAA######';
    },
    getFileTypeHasDescription (fileType) {
      if (this.guarantee.type !== 'Zastaw rejestrowy na udziałach spółki') {
        return false
      }

      return fileType === 'other_files' || fileType === '';
    },
    showObligationsModal () {
      this.isObligationsModalVisible = true;
    },
    handleObligationsClose (shouldReload = false) {
      this.isObligationsModalVisible = false;
      if (shouldReload) {
        this.$emit('guarantee-updated');
      }
    },
    handleObligationsSaved () {
      this.isObligationsModalVisible = false;
      this.$emit('guarantee-updated');
    }
  },
  beforeDestroy () {
    this.$validator.reset();
  }
}
</script>

<style scoped>
  .list-group-item table{
      margin-bottom: 0;
  }
</style>
